import { isDevMode } from '@angular/core';

/** Severity for development-only grid orchestration logging. */
export enum GridOrchestrationLogLevel {
  Warn = 'warn',
  Error = 'error'
}

/** Logs a grid orchestration message in development builds only. */
export function logGridOrchestration(
  level: GridOrchestrationLogLevel,
  message: string,
  ...details: Array<unknown>
): void {
  if (!isDevMode()) {
    return;
  }

  switch (level) {
    case GridOrchestrationLogLevel.Warn:
      console.warn(message, ...details);
      break;
    case GridOrchestrationLogLevel.Error:
      console.error(message, ...details);
      break;
  }
}
